<template>
  <td>{{ createdDate + " " + createdTime }}</td>
  <td>{{ message.email }}</td>
  <td>{{ message.name }}</td>
  <td>{{ message.phone }}</td>
  <td>
    <div class="message-container">{{ message.messageContent }}</div>
  </td>
  <td>
    <BootstrapIcon
      class="listTableIcon"
      data-bs-toggle="modal"
      :data-bs-target="'#' + 'a' + message._id"
      icon="envelope-open"
    />
    <BootstrapIcon
      class="listTableIcon delete"
      icon="trash"
      @click="deleteItem(message._id)"
    />
  </td>

  <!-- Message Modal -->
  <div
    class="modal"
    :id="'a' + message._id"
    tabindex="-1"
    aria-labelledby="emailModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="emailModalLabel">Email Message</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="card">
            <div class="card-body">
              {{ message.messageContent }}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import authHeader from "../../services/authHeader";

export default {
  name: "AdminEmailTable",
  props: ["message"],
  data() {
    return {
      displayEdit: false,
      displayMessage: false,
      createdDate: this.message.createdDate.substring(0, 10),
      createdTime: this.message.createdDate.substring(11, 19),
    };
  },
  methods: {
    deleteItem(id) {
      console.log(id);
      axios
        .put(
          this.$webDomain + "/gardenNew/gardenMessageDelete",
          {
            itemId: id,
          },
          {
            headers: authHeader(),
          }
        )
        .then(function(response) {
          console.log(response);
          window.location.reload();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>
